class APIError extends Error {
	constructor(message, code = 500) {
		super(message);

		this.name = 'APIError';
		this.code = code;
	}
}

export default APIError;
